import { Typography } from '../kit';
import { themeColors } from '../theme/theme';
import { useTranslation } from '@/kit/useTranslation';

export default function SummaryCard({ origin, destination, parcelType, parcelWeight }) {
  const { t } = useTranslation();
  return (
    <div
      style={{
        background: '#fff',
        borderRadius: 16,
        boxShadow: `0 2px 12px ${themeColors.primaryColor}11`,
        padding: '1.5em 1em',
        margin: '1.5em 0',
        maxWidth: 420,
        marginLeft: 'auto',
        marginRight: 'auto',
        position: 'relative',
      }}
    >
      <Typography
        type="h3"
        text={t('parcel.summary')}
        style={{
          color: themeColors.primaryColor,
          fontWeight: 700,
          marginBottom: 16,
          fontSize: 22,
        }}
      />
      <Typography
        type="text"
        text={t('parcel.pickupLabel', {
          address: `${origin?.building || ''}, ${origin?.landmark || ''}`,
        })}
        style={{ marginBottom: 6 }}
      />
      <Typography
        type="text"
        text={t('parcel.dropoffLabel', {
          address: `${destination?.building || ''}, ${destination?.landmark || ''}`,
        })}
        style={{ marginBottom: 6 }}
      />
      <Typography
        type="text"
        text={t('parcel.contactLabel', { contact: origin?.contact || '' })}
        style={{ marginBottom: 6 }}
      />
      <Typography
        type="text"
        text={t('parcel.parcelTypeLabel', { type: parcelType || '' })}
        style={{ marginBottom: 6 }}
      />
      <Typography
        type="text"
        text={t('parcel.weightVolumeLabel', { value: parcelWeight || '' })}
        style={{ marginBottom: 6 }}
      />
    </div>
  );
}
